export const MIXIN_FORM_NAME = 'mixin_form';
export const DISPATCH_INPUT_EVENT = 'dispatch_input';
export const INPUT_UPDATE_EVENT = 'input-update';

export const ROL_EPB_CONTROLEUR = 'EPB_CONTROLEUR';
export const ROL_DESK_D = 'DESK_D';
export const ROL_STUDENT_TYPED = 'STUDENT_TYPED';

export const CERTIFICATEN_TABLE_STORAGE_KEY = 'CertificaatTableColumns';
export const ERKENNING_BEPERKT_DIALOG_SHOWN_KEY = 'ErkenningBeperktDialogShown';

export const VALID_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;